import React from 'react';
import PropTypes from 'prop-types';
import ModalPage from 'containers/pages/ModalPage/ModalPage';
import TermsAndConditions from '../../../components/TermsAndConditions';
import ModalSubHeader from '../../../components/ModalSubHeader';
import SignUpForm from '../../../components/SignUp/form.js';
import AppPaths from '../../../AppPaths';
import LoginRouter from 'containers/routers/LoginRouter';
import SignupErrorModal from '../SignupErrorModal/SignupErrorModal';

const SignupPage = ({ hideEmail = false }) => {
  const subHeaderProps = {
    message: 'Already have an account? ',
    to: AppPaths.LoginPage,
    linkTitle: 'Sign in.',
  };

  return (
    <LoginRouter>
      <ModalPage
        header="Welcome to Shoflo"
        subHeader={<ModalSubHeader {...subHeaderProps} />}
        footer={<TermsAndConditions />}
      >
        <SignUpForm hideEmail={hideEmail} />
      </ModalPage>
      <SignupErrorModal />
    </LoginRouter>
  );
};

SignupPage.propTypes = {
  hideEmail: PropTypes.bool,
};

export default SignupPage;
